import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import { DataProviderInstance } from '../../../api/DataProvider';
import { formatDate } from '../../../utils/Utils';
import ConfirmPopup from '../../../popup/ConfirmPopup/ConfirmPopup';
import SourceAvatar from '../shared/SourceAvatar';
import RowAction from '../shared/RowAction';
import shared from '../shared/MarketingShared.module.css';
import styles from './Sources.module.css';

// `onBlockedAction`: quando informado (plano sem marketing), excluir abre o
// modal de upgrade em vez de chamar a API.
const SourceRow = ({ sourceData, onEdit, onUpdate, onBlockedAction = null }) => {
  const { CompanyConfig, DeleteMarketingChannel } = DataProviderInstance();
  const navigate = useNavigate();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  // Erro do servidor ao excluir: aparece no mesmo popup, no lugar do alert()
  const [deleteError, setDeleteError] = useState('');
  const { id, name, createdAt } = sourceData;

  // Origem ligada a campanhas não pode ser excluída (delete_source.php):
  // o popup já avisa em vez de pedir a confirmação
  const campaignsUsingSource = (CompanyConfig.LeadsCampaigns || []).filter((campaign) => campaign.sourceId == id).length;

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onBlockedAction) { onBlockedAction(); return; }
    setShowDeleteConfirm(true);
  };

  const confirmDelete = () => {
    DeleteMarketingChannel(id, (response) => {
      if (response.status == "success") {
        onUpdate();
      } else {
        setDeleteError(response.message || response.error || "Não foi possível excluir a origem.");
        setShowDeleteConfirm(true);
      }
    });
    setShowDeleteConfirm(false);
  };

  const cancelDelete = () => {
    setShowDeleteConfirm(false);
    setDeleteError('');
  };

  const deletePopupProps = () => {
    if (deleteError) {
      return { Title: 'Não foi possível excluir', Description: deleteError, ConfirmLabel: 'Entendi', OnConfirm: () => {} };
    }
    if (campaignsUsingSource > 0) {
      const campaignsText = campaignsUsingSource === 1 ? '1 campanha' : `${campaignsUsingSource} campanhas`;
      return {
        Title: 'Origem em uso',
        Description: `A origem "${name}" está ligada a ${campaignsText}. Troque a origem ou exclua essas campanhas antes de excluir a origem.`,
        ConfirmLabel: 'Ver campanhas',
        OnConfirm: () => navigate('/marketing/campaigns'),
      };
    }
    return { Title: 'Excluir Origem', Description: `Tem certeza que deseja excluir a origem "${name}"?`, ConfirmLabel: 'Excluir', OnConfirm: confirmDelete };
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit(sourceData);
  };

  const formattedCreatedAt = createdAt ? formatDate(new Date(createdAt)) : '';

  return (
    <li className={`${shared.row} ${styles.row}`}>
      <SourceAvatar name={name} />

      <div className={shared.identity}>
        <span className={shared.name}>{name}</span>
      </div>

      <span className={shared.date}>
        {formattedCreatedAt && (
          <>
            <EventOutlinedIcon className={shared.dateIcon} />
            Criada em {formattedCreatedAt}
          </>
        )}
      </span>

      <span className={shared.actions}>
        <RowAction title="Editar" onClick={handleEdit}>
          <EditOutlinedIcon style={{ fontSize: 17 }} />
        </RowAction>
        <RowAction title="Excluir" tone="danger" onClick={handleDelete}>
          <DeleteOutlineRoundedIcon style={{ fontSize: 18 }} />
        </RowAction>
      </span>

      {showDeleteConfirm && (
        <ConfirmPopup
          Visibility={showDeleteConfirm}
          {...deletePopupProps()}
          OnCancel={cancelDelete}
          OnHide={cancelDelete}
        />
      )}
    </li>
  );
};

export default SourceRow;
